import { useUtilities } from "@ultracommerce/react-storefront/global";

const BasicCard = (props) => {
  let { eventHandlerForWSIWYG } = useUtilities();
  const {
    stylingCustomClasses = "",
    imagePosition = "top",
    contentElementID,
    contentCardImage,
    contentHeading = "",
    contentSubHeading = "",
    contentBody = "",
    bootStrapLayoutClass,
    customStyleClasses,
  } = props;
  const { linkLabel = "", linkUrl = "", urlTarget = "_self" } = props;
  return (
    <>
    <div className="col-12">
    {linkLabel?.trim()?.length > 0 && (
     <a
            className=""
            style={{}}
            rel="noreferrer"
            href={linkUrl}
            target={urlTarget}
          >
    <div
      className={[
        `card overflow-hidden swBasicCard align-items-center text-break border-0 ${
          bootStrapLayoutClass ? bootStrapLayoutClass : ""
        }`,
        stylingCustomClasses,
        customStyleClasses
      ].join(" ")}
      id={contentElementID}
    >
      <div>
        {imagePosition === "top" && contentCardImage?.trim()?.length > 0 && (
          <img src={contentCardImage} style={{ width: "100%" }} className="card-img-top align-self-center zoom-in p-5 px-lg-150 " alt="" />
        )}
      </div>
      <div className="card-body d-flex flex-column px-4 pt-0" onClick={eventHandlerForWSIWYG}>
        <div className="flex-grow-1 w-100">
          {contentHeading?.trim()?.length > 0 && (
            <h4 className="card-title font-weight-bold">{contentHeading}</h4>
          )}
          {contentSubHeading?.trim()?.length > 0 && (
            <h6 className="card-subtitle font-weight-bold mb-2 text-muted">{contentSubHeading}</h6>
          )}
          {contentBody?.trim()?.length > 0 && (
            <div className="card-text" dangerouslySetInnerHTML={{ __html: contentBody }} />
          )}
        </div>

          <h2
            className="btn btn-primary mt-4 d-block mx-auto"
            style={{ width: "fit-content" }}
            rel="noreferrer"
            href={linkUrl}
            target={urlTarget}
          >
            {linkLabel}
          </h2>
    
      </div>
            

    </div>
    </a>
        )}
        </div>
        </>
  );
};

const HorizontalCard = (props) => {
  let { eventHandlerForWSIWYG } = useUtilities();
  const {
    imagePosition = "left",
    contentElementID,
    contentCardImage,
    contentHeading = "",
    contentSubHeading = "",
    contentBody = "",
    optionalBackgroundImage=""
  } = props;
  const { linkLabel = "", linkUrl = "", urlTarget = "_self" } = props;

  return (
    <div className="card overflow-hidden" id={contentElementID}>
      <div className="row g-0" style={optionalBackgroundImage ? { flex: "1", background: `url(${optionalBackgroundImage}) no-repeat center center /cover` }:{ flex: "1" }}>
        {imagePosition === "left" && (
          <div className="col-md-6 d-flex" style={{ maxHeight: "250px" }}>
            {contentCardImage?.trim()?.length > 0 && (
              <img src={contentCardImage} className="img-fluid" style={{ objectFit: "contain" }} alt="" />
            )}
          </div>
        )}
        <div className="col-md-6">
          <div className="card-body" onClick={eventHandlerForWSIWYG}>
            {contentHeading?.trim()?.length > 0 && (
              <h5 className="card-title text-uppercase font-weight-bold">{contentHeading}</h5>
            )}
            {contentSubHeading?.trim()?.length > 0 && (
              <h6 className="card-subtitle font-weight-bold mb-2">{contentSubHeading}</h6>
            )}
            {contentBody?.trim()?.length > 0 && (
              <div
                onClick={eventHandlerForWSIWYG}
                className="card-text"
                dangerouslySetInnerHTML={{ __html: contentBody }}
              />
            )}
            {linkLabel?.trim()?.length > 0 && (
              <a className="btn btn-primary w-100 mt-4" rel="noreferrer" href={linkUrl} target={urlTarget}>
                {linkLabel}
            </a>
            )}
          </div>
        </div>
        {imagePosition === "right" && (
          <div className="col-md-6 d-flex" style={{ maxHeight: "250px" }}>
            {contentCardImage?.trim()?.length > 0 && (
              <img src={contentCardImage} className="img-fluid" style={{ objectFit: "contain" }} alt="" />
            )}
          </div>
        )}

      </div>
    </div>
  );
};

const OverlayCard = (props) => {
  let { eventHandlerForWSIWYG } = useUtilities();
  const {
    overlayType = "left",
    contentElementID,
    contentCardImage,
    contentHeading = "",
    contentSubHeading = "",
    contentBody = "",
  } = props;
  const { linkLabel = "", linkUrl = "", urlTarget } = props;

  return (
    <div className={`card overflow-hidden card-${overlayType}`} id={contentElementID}>
      <div className="card-img-container">
        {contentCardImage?.trim()?.length > 0 && <img src={contentCardImage} className="card-img-overlay" alt="" />}
      </div>
      <div
        className={`px-4 card-overlay card-overlay-${overlayType} ${overlayType === "heading" && "p-4"}`}
        onClick={eventHandlerForWSIWYG}
        >
        {contentHeading?.trim()?.length > 0 && (
          <h5 className="card-title text-uppercase font-weight-bold">{contentHeading}</h5>
        )}
        {contentSubHeading?.trim()?.length > 0 && (
          <h6 className="card-subtitle font-weight-bold mb-2">{contentSubHeading}</h6>
        )}
        {contentBody?.trim()?.length > 0 && (
          <div className="card-text" dangerouslySetInnerHTML={{ __html: contentBody }} />
        )}
        {linkLabel?.trim()?.length > 0 && (
          <a className="btn btn-primary w-100 mt-4" rel="noreferrer" href={linkUrl} target={urlTarget}>
            {linkLabel}
          </a>
        )}

      </div>
    </div>
  );
};

export { BasicCard, OverlayCard, HorizontalCard };
